var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switchIdentity',{attrs:{"list":_vm.memberStores,"selected":_vm.selectedStore,"title":"請選擇要管理的商家","register_btn":"申請新商家"},on:{"switchIdentity":_vm.clickSwitchIdentity,"register":_vm.clickRegisterStore}})}
var staticRenderFns = []

export { render, staticRenderFns }